import http from '@/utils/http';

/**
 * 分页查询客户系交接明细-cyj
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/asset/transfer/customerGroup/page',
        method: 'post',
        data
    });
};

/**
 * 保存/批量保存客户系交接明细-cyj
 */
export function updateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/customerGroup/save',
        method: 'post',
        data
    });
};

/**
 * 修改/批量修改客户系交接明细-cyj
 */
export function batchUpdateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/customerGroup/batchSave',
        method: 'post',
        data
    });
};

/**
 * 导入-cyj
 */
export function importAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/customerGroup/importCustomerGroup',
        method: 'post',
        data
    });
};
